import React, { Suspense } from 'react';
import { ILmpBlock } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LmpBlockWrapper = React.lazy(() => import('./match-hero'));
export interface IDynamicLmpBlockWrapper extends IComponentModel<ILmpBlock> {
  live?: boolean;
  model: any;
}

const DynamicLmpBlock = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicLmpBlockWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <LmpBlockWrapper live={live} initialModel={validateModel(model) as ILmpBlock} query={validateModel(query)} />
  </Suspense>
);

DynamicLmpBlock.defaultProps = {
  live: false,
};

export default DynamicLmpBlock;
